// Thema's (feat/themas), zie themesApp.nl.ts.
export const appThemesTr = {
    audience: 'Bu panonun teması',
    audienceHint: 'Daha sonra Tabletler bölümünden veya panodaki Değiştir ile değiştirebilirsin (ekran başına da).',
    adult: 'Aile ve yetişkinler',
    adultHint: 'Yetişkin teması: sakin ve sade, nötr renkler ve çizgi simgeler.',
    kids: 'Çocuklar',
    kidsHint: 'Çocuk teması: renkli simgeler, daha büyük düğmeler ve yazı. Pano çocukların odasındaysa yalnızca onların şeylerini gösterir.',
    pictos: 'Uygulamadaki simgeler',
    pictosHint: 'Bu cihazda geçerli.',
    pictosClean: 'Sade (sakin çizgiler)',
    pictosColor: 'Eğlenceli (renkli)',
};
//# sourceMappingURL=themesApp.tr.js.map